<template>
  <div class="relative w-full h-full overflow-y-auto p-4">
    <div class="bg-white rounded-lg p-6 mb-4">
      <div class="flex justify-between items-center mb-4">
        <h2 class="font-bold text-xl">Ankündigungen</h2>
        <button v-if="user.Announcements >= 1 && !editing" @click="startCreate">Neue Ankündigung</button>
      </div>

      <div v-if="editing" class="mb-6 border rounded p-4">
        <h3 class="font-bold text-lg mb-4">{{ form.id ? 'Ankündigung bearbeiten' : 'Neue Ankündigung' }}</h3>
        <div class="grid grid-cols-1 gap-4">
          <div><label>Titel</label><input v-model="form.Titel" class="border-2 border-gray-200 px-2 py-1 w-full"></div>
          <div><label>Inhalt</label><textarea v-model="form.Inhalt" rows="4" class="border-2 border-gray-200 px-2 py-1 w-full"></textarea></div>
          <div><label>Buchungslink</label><input v-model="form.Buchungslink" class="border-2 border-gray-200 px-2 py-1 w-full"></div>
          <div><label>Infolink</label><input v-model="form.Infolink" class="border-2 border-gray-200 px-2 py-1 w-full"></div>
          <div>
            <label>Bild</label>
            <input type="file" accept="image/*" @change="onImageChange" class="border-2 border-gray-200 px-2 py-1 w-full">
            <img v-if="form.image" :src="'data:image/jpeg;base64,' + form.image" class="mt-2 max-w-xs rounded">
          </div>
          <div class="flex items-center">
            <input v-model="form.Aktiv" type="checkbox" id="annAktiv" class="small mr-2" />
            <label for="annAktiv" class="text-sm font-medium">Aktiv</label>
          </div>
        </div>
        <div class="mt-4 flex gap-4">
          <button @click="saveAnnouncement">Speichern</button>
          <button @click="cancelEdit" class="bg-gray-300">Abbrechen</button>
        </div>
        <div v-if="saveError" class="mt-4 text-red-600">{{ saveError }}</div>
      </div>

      <div v-for="ann in announcements" :key="ann.id" class="border rounded p-4 mb-4">
        <div class="flex justify-between items-start">
          <div>
            <h3 class="font-bold text-lg">{{ ann.Titel || '(ohne Titel)' }}</h3>
            <p class="text-gray-600">{{ ann.Inhalt }}</p>
            <div class="flex gap-4 mt-2 text-sm text-blue-600">
              <a v-if="ann.Buchungslink" :href="ann.Buchungslink" target="_blank">Buchungslink</a>
              <a v-if="ann.Infolink" :href="ann.Infolink" target="_blank">Infolink</a>
            </div>
            <span class="inline-block mt-2 px-2 py-1 rounded text-xs" :class="ann.Aktiv ? 'bg-green-100 text-green-700' : 'bg-gray-200'">
              {{ ann.Aktiv ? 'Aktiv' : 'Inaktiv' }}
            </span>
          </div>
          <div v-if="user.Announcements >= 1" class="flex gap-2">
            <button @click="startEdit(ann)">Bearbeiten</button>
            <button v-if="user.Announcements >= 1" @click="confirmDelete(ann)" class="text-red-600">Löschen</button>
          </div>
        </div>
        <img v-if="ann.image" :src="'data:image/jpeg;base64,' + ann.image" class="mt-4 max-w-sm rounded">
      </div>
      <div v-if="announcements.length === 0 && !editing" class="text-gray-500 text-center py-8">
        Keine Ankündigungen vorhanden.
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/API";
export default {
  name: "Announcements",
  props: ["user"],
  data() {
    return {
      announcements: [],
      editing: false,
      form: {},
      selectedImage: null,
      saveError: null,
    };
  },
  methods: {
    loadAnnouncements() {
      API.getAdminAnnouncements((r) => { this.announcements = r; });
    },
    startCreate() {
      this.form = { Titel: "", Inhalt: "", Buchungslink: "", Infolink: "", Aktiv: true };
      this.selectedImage = null;
      this.editing = true;
      this.saveError = null;
    },
    startEdit(ann) {
      this.form = { ...ann };
      this.selectedImage = null;
      this.editing = true;
      this.saveError = null;
    },
    cancelEdit() {
      this.editing = false;
      this.form = {};
    },
    onImageChange(e) {
      this.selectedImage = e.target.files[0];
    },
    saveAnnouncement() {
      this.saveError = null;
      if (this.form.id) {
        API.updateAnnouncement(this.form.id, this.form, (r, status) => {
          if (status === 200) {
            if (this.selectedImage) {
              API.uploadAnnouncementImage(this.form.id, this.selectedImage, () => {
                this.editing = false;
                this.loadAnnouncements();
              });
            } else {
              this.editing = false;
              this.loadAnnouncements();
            }
          } else {
            this.saveError = "Speichern fehlgeschlagen";
          }
        });
      } else {
        API.createAnnouncement(this.form, (r, status) => {
          if (status === 201) {
            if (this.selectedImage) {
              API.uploadAnnouncementImage(r.id, this.selectedImage, () => {
                this.editing = false;
                this.loadAnnouncements();
              });
            } else {
              this.editing = false;
              this.loadAnnouncements();
            }
          } else {
            this.saveError = "Erstellen fehlgeschlagen";
          }
        });
      }
    },
    confirmDelete(ann) {
      if (confirm(`Ankündigung "${ann.Titel}" wirklich löschen?`)) {
        API.deleteAnnouncement(ann.id, () => { this.loadAnnouncements(); });
      }
    },
  },
  created() {
    this.loadAnnouncements();
  },
};
</script>

<style scoped>
label { display: block; font-weight: bold; margin-bottom: 4px; }
</style>
